export const route = {
  basename: "/front",
  soon: "/court/soon", // 가오픈
  mainPath: "/court/main", // 메인페이지로 사용하는 path (현재는 신청/계약 목록)
  mypage: "/court/mypage/main", //마이페이지 경로
  myContracts: "/court/mypage/contracts/:contractId", //마이페이지 경로
};
